import React, {useEffect, useState} from 'react';
// import { Link } from 'react-router-dom';
import { listReviews } from '../api/reviewsApi';
import ReviewCard from '../components/ReviewCard';
import SearchBar from '../components/SearchBar';

export default function ReviewList(){
  const [reviews, setReviews] = useState([]);
  const [query, setQuery] = useState('');
  const [platform, setPlatform] = useState('All');
  const [sort, setSort] = useState('newest');

  useEffect(()=> {
    listReviews().then(setReviews);
  }, []);

  const filtered = reviews.filter(r => {
    const q = query.toLowerCase();
    if (platform !== 'All' && r.platform !== platform) return false;
    if (!q) return true;
    return [r.title, r.summary, r.genre, r.author].join(' ').toLowerCase().includes(q);
  }).sort((a,b)=>{
    if (sort === 'newest') return new Date(b.date) - new Date(a.date);
    if (sort === 'rating') return b.rating - a.rating;
    if (sort === 'alphabet') return a.title.localeCompare(b.title, undefined, { sensitivity: 'base' });
    if (sort === 'dev') return a.developer.localeCompare(b.developer, undefined, { sensitivity: 'base' });
    if (sort === 'pub') return a.publisher.localeCompare(b.publisher, undefined, { sensitivity: 'base' });
    if (sort === 'plat') return a.platform.localeCompare(b.platform, undefined, { sensitivity: 'base' });
    return 0;
  });
  
  const platforms = ['All', 'PC','PlayStation','Xbox','Nintendo','Mobile'];

  return (
    <div>
      <div className='filters' style={{display:'flex',alignItems:'center',gap:12,marginBottom:12,flexWrap:'wrap'}}>
        <SearchBar value={query} onChange={setQuery} />
        <select className="input" value={platform} onChange={e=>setPlatform(e.target.value)} aria-label="Filter by platform">
          {platforms.map(p=> <option key={p} value={p}>{p}</option>)}
        </select>
        <select className="input" value={sort} onChange={e=>setSort(e.target.value)} aria-label="Sort reviews">
          <option value="rating">Top rated</option>
          <option value="newest">Newest</option>
          <option value="dev">Developer</option>
          <option value="pub">Publisher</option>
          <option value="plat">Platform</option>
          <option value="alphabet">Alphabetical</option>
        </select>
      </div>

      <section className="grid" aria-live="polite">
        {filtered.length ? filtered.map(r => <ReviewCard key={r.id} review={r} />) : <div className="card">No reviews found.</div>}
      </section>
    </div>
  );
}
